import { useSession } from 'next-auth/react';

import { EventDto } from '@web/services/crm-api/rest';

import { getEventStatus } from '@web/utils/event-status';

export function useEventStatus(eventDto: EventDto) {
	const { status } = useSession();

	return getEventStatus(eventDto, status === 'authenticated');
}
